module.exports = __webpack_public_path__ + "static/media/meter.2d901db5.svg";